<script lang="ts">
    import { gettext as _ } from 'hydria/services/gettext'
    import { translatedSupportedLanguages } from 'hydria/services/language'

    interface Props {
        value: string;
        disabled?: boolean;
    }

    let { value = $bindable(), disabled = false }: Props = $props();

    if ($translatedSupportedLanguages.length == 1) {
        if (value !== $translatedSupportedLanguages[0].lg) {
            value = $translatedSupportedLanguages[0].lg
        }
    }
</script>

{#if $translatedSupportedLanguages.length > 1}
    <div class="row g-3 align-items-center">
        <div class="col-2 text-end"><label for="f-nil" class="col-form-label">{$_('Langue')}</label></div>
        <div class="col-auto">
            <div class="btn-group">
                {#each $translatedSupportedLanguages as { lg, text }}
                    <button type="button" class="btn btn-outline-secondary" class:active={lg === value} onclick={() => (value = lg)} {disabled}>{text}</button>
                {/each}
            </div>
        </div>
    </div>
{/if}
